(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderDetails extends HTMLElement {
    constructor() {
      super();

      this.detailsElement = this.querySelector('details');
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    onMouseEnter() {
      this.detailsElement.setAttribute('open', '');
    }

    onMouseLeave() {
      this.detailsElement.removeAttribute('open');
    }
  }

  customElements.define('header-details', HeaderDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // C3 fix 2026-07-16: null-guard. Element „mehr Farben anzeigen" istnieje TYLKO na PDP
  // z odpowiednio długą listą wariantów kolorystycznych. Bez guarda querySelector zwraca
  // null na każdym pozostałym PDP → TypeError: null.addEventListener. Shopify łapie go
  // w try/catch per sekcja (więc nie ubijał całej strony), ale przerywał resztę TEGO bloku
  // i zaśmiecał konsolę na KAŻDYM PDP, maskując realne błędy.
  const colorShowMore = document.querySelector('.product__color-variations-list-show-more');
  if (colorShowMore) {
    colorShowMore.addEventListener(
      'click',
      (e) => {
        e.target.closest('ul').classList.toggle('product__color-variations-list--show-all');
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-slider"] && !Shopify.designMode) return;
  try {
    
  class StepSlider extends HTMLElement {
    constructor() {
      super();

      this.currentStep = 0;
      this.maxSteps = +this.dataset.maxSteps;
      this.prevButton = this.querySelector('.slider-button[name="previous"]');
      this.nextButton = this.querySelector('.slider-button[name="next"]');
      this.currentStepWrapper = this.querySelector('.step-slider__current-step-wrapper');
      this.slidesWrapper = this.querySelector('.step-slider__texts');
      this.slides = this.querySelectorAll('.step-slider__slide');

      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      this.slidesWrapper.addEventListener('keyup', this.onListKeyUp.bind(this));
    }

    update() {
      this.style.setProperty('--current-step', this.currentStep);

      if (this.currentStep === this.maxSteps) {
        this.disableButton(this.nextButton);
      } else {
        this.enableButton(this.nextButton);
      }

      if (this.currentStep === 0) {
        this.disableButton(this.prevButton);
      } else {
        this.enableButton(this.prevButton);
      }

      this.currentStepWrapper.innerText = this.currentStep + 1;
      this.setSlideAccessibility();
    }

    setSlideAccessibility() {
      this.slides.forEach((slide, index) => {
        if (index === this.currentStep) {
          slide.ariaHidden = 'false';
          return;
        }

        slide.ariaHidden = 'true';
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      if (event.currentTarget.name === 'next') {
        this.currentStep = Math.min(this.currentStep + 1, this.maxSteps);
      } else {
        this.currentStep = Math.max(this.currentStep - 1, 0);
      }

      this.update();
    }

    onListKeyUp(event) {
      event.preventDefault();

      switch (event.key) {
        case 'ArrowRight':
          this.currentStep = Math.min(this.currentStep + 1, this.maxSteps);
          break;
        case 'ArrowLeft':
          this.currentStep = Math.max(this.currentStep - 1, 0);
          break;
        default:
          return;
      }

      this.update();
    }

    disableButton(buttonElem) {
      buttonElem.ariaDisabled = 'true';
      buttonElem.disabled = true;
    }

    enableButton(buttonElem) {
      buttonElem.removeAttribute('aria-disabled');
      buttonElem.removeAttribute('disabled');
    }
  }

  customElements.define('step-slider', StepSlider);

  } catch(e) { console.error(e); }
})();
})();
